import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import Image from 'next/image'
import fitty from 'fitty'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  platform: Array<Platform>
  voiceChat: Array<0 | 1 | 2 | 3 | 4 | 5>
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  fontFamily: string
  fontColor: string
  hitokoto: string
  dbdSurvivor: number[]
  dbdKiller: number[]
}

export const DBD3: React.FC<Props> = ({
  targetId,
  name,
  templateColor,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playTimeWeekEndBegin,
  playTimeWeekEndEnd,
  platform,
  voiceChat,
  dbdSurvivor,
  dbdKiller,
  fontFamily,
  fontColor,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 18,
      minSize: 12,
    })
    fitty('#uid', {
      maxSize: 15,
      minSize: 8,
    })
    fitty('#platform', {
      maxSize: 15,
      minSize: 8,
    })
    fitty('#voiceChat', {
      maxSize: 15,
      minSize: 6,
    })
    fitty('#playStyle', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#hitokoto', {
      maxSize: 22,
      minSize: 12,
    })
  }, [])
  return (
    <ProfileContainer>
      <ProfileInner id={targetId} fontFamily={fontFamily} color={fontColor}>
        <Image
          width="1536"
          height="2048"
          priority={true}
          unoptimized={true}
          src={`/static/images/profiles/dbd3/${templateColor}.jpeg`}
          alt={`DbD自己紹介カード ${templateColor}`}
        />
        <Name>
          <span id="name">{name}</span>
        </Name>
        {platform.includes(0) && <Platform0 />}
        {platform.includes(1) && <Platform1 />}
        {platform.includes(3) && <Platform2 />}
        {platform.includes(2) && <Platform3 />}
        <PlayTimeWeekDay>
          平日{playTimeWeekDayBegin}〜{playTimeWeekDayEnd}時
        </PlayTimeWeekDay>
        <PlayTimeWeekEnd>
          休日{playTimeWeekEndBegin}〜{playTimeWeekEndEnd}時
        </PlayTimeWeekEnd>
        <VCText color={fontColor}>
          <span id="voiceChat">
            {voiceChat.includes(0) && ' Skype '}
            {voiceChat.includes(1) && ' LINE '}
            {voiceChat.includes(2) && ' プレステ '}
            {voiceChat.includes(3) && ' Discord '}
            {voiceChat.includes(5) && ' Switch '}
          </span>
        </VCText>
        {(voiceChat.includes(0) ||
          voiceChat.includes(1) ||
          voiceChat.includes(3)) && <VCOk />}
        {voiceChat.includes(4) && <VCNg />}
        {dbdKiller.includes(0) && <Killer0 color={fontColor} />}
        {dbdKiller.includes(1) && <Killer1 color={fontColor} />}
        {dbdKiller.includes(2) && <Killer2 color={fontColor} />}
        {dbdKiller.includes(3) && <Killer3 color={fontColor} />}
        {dbdKiller.includes(4) && <Killer4 color={fontColor} />}
        {dbdKiller.includes(5) && <Killer5 color={fontColor} />}
        {dbdKiller.includes(6) && <Killer6 color={fontColor} />}
        {dbdKiller.includes(7) && <Killer7 color={fontColor} />}
        {dbdKiller.includes(8) && <Killer8 color={fontColor} />}
        {dbdKiller.includes(9) && <Killer9 color={fontColor} />}
        {dbdKiller.includes(10) && <Killer10 color={fontColor} />}
        {dbdKiller.includes(11) && <Killer11 color={fontColor} />}
        {dbdKiller.includes(12) && <Killer12 color={fontColor} />}
        {dbdKiller.includes(13) && <Killer13 color={fontColor} />}
        {dbdKiller.includes(14) && <Killer14 color={fontColor} />}
        {dbdKiller.includes(15) && <Killer15 color={fontColor} />}
        {dbdKiller.includes(16) && <Killer16 color={fontColor} />}
        {dbdKiller.includes(17) && <Killer17 color={fontColor} />}
        {dbdKiller.includes(18) && <Killer18 color={fontColor} />}
        {dbdKiller.includes(19) && <Killer19 color={fontColor} />}
        {dbdKiller.includes(20) && <Killer20 color={fontColor} />}
        {dbdKiller.includes(21) && <Killer21 color={fontColor} />}
        {dbdKiller.includes(22) && <Killer22 color={fontColor} />}
        {dbdKiller.includes(23) && <Killer23 color={fontColor} />}
        {dbdKiller.includes(24) && <Killer24 color={fontColor} />}
        {dbdKiller.includes(25) && <Killer25 color={fontColor} />}
        {dbdKiller.includes(26) && <Killer26 color={fontColor} />}
        {dbdKiller.includes(27) && <Killer27 color={fontColor} />}
        {dbdKiller.includes(28) && <Killer28 color={fontColor} />}
        {dbdSurvivor.includes(0) && <Survivor0 color={fontColor} />}
        {dbdSurvivor.includes(1) && <Survivor1 color={fontColor} />}
        {dbdSurvivor.includes(2) && <Survivor2 color={fontColor} />}
        {dbdSurvivor.includes(3) && <Survivor3 color={fontColor} />}
        {dbdSurvivor.includes(4) && <Survivor4 color={fontColor} />}
        {dbdSurvivor.includes(5) && <Survivor5 color={fontColor} />}
        {dbdSurvivor.includes(6) && <Survivor6 color={fontColor} />}
        {dbdSurvivor.includes(7) && <Survivor7 color={fontColor} />}
        {dbdSurvivor.includes(8) && <Survivor8 color={fontColor} />}
        {dbdSurvivor.includes(9) && <Survivor9 color={fontColor} />}
        {dbdSurvivor.includes(10) && <Survivor10 color={fontColor} />}
        {dbdSurvivor.includes(11) && <Survivor11 color={fontColor} />}
        {dbdSurvivor.includes(12) && <Survivor12 color={fontColor} />}
        {dbdSurvivor.includes(13) && <Survivor13 color={fontColor} />}
        {dbdSurvivor.includes(14) && <Survivor14 color={fontColor} />}
        {dbdSurvivor.includes(15) && <Survivor15 color={fontColor} />}
        {dbdSurvivor.includes(16) && <Survivor16 color={fontColor} />}
        {dbdSurvivor.includes(17) && <Survivor17 color={fontColor} />}
        {dbdSurvivor.includes(18) && <Survivor18 color={fontColor} />}
        {dbdSurvivor.includes(19) && <Survivor19 color={fontColor} />}
        {dbdSurvivor.includes(20) && <Survivor20 color={fontColor} />}
        {dbdSurvivor.includes(21) && <Survivor21 color={fontColor} />}
        {dbdSurvivor.includes(22) && <Survivor22 color={fontColor} />}
        {dbdSurvivor.includes(23) && <Survivor23 color={fontColor} />}
        {dbdSurvivor.includes(24) && <Survivor24 color={fontColor} />}
        {dbdSurvivor.includes(25) && <Survivor25 color={fontColor} />}
        {dbdSurvivor.includes(26) && <Survivor26 color={fontColor} />}
        {dbdSurvivor.includes(27) && <Survivor27 color={fontColor} />}
        {dbdSurvivor.includes(28) && <Survivor28 color={fontColor} />}
        {dbdSurvivor.includes(29) && <Survivor29 color={fontColor} />}
        {dbdSurvivor.includes(30) && <Survivor30 color={fontColor} />}
        {dbdSurvivor.includes(31) && <Survivor31 color={fontColor} />}
        {dbdSurvivor.includes(32) && <Survivor32 color={fontColor} />}
      </ProfileInner>
    </ProfileContainer>
  )
}

const ProfileContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4c4c4c;
`

const ProfileInner = styled.div<{ fontFamily: string; color: string }>`
  position: relative;
  line-height: 0;
  width: 280px;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ color }) => color};
  }
`

const Name = styled.div`
  position: absolute;
  top: 9%;
  left: 6%;
  width: 36%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const PlatformBase = styled.div`
  position: absolute;
  top: 14.5%;
  left: 52%;
  border-style: solid;
  border-width: 2px;
  border-radius: 12px;
  width: 28px;
  height: 16px;
`

const Platform0 = styled(PlatformBase)``
const Platform1 = styled(PlatformBase)`
  left: 61%;
`
const Platform2 = styled(PlatformBase)`
  left: 71%;
`

const Platform3 = styled(PlatformBase)`
  left: 81.5%;
`

const PlayTimeBase = styled.span`
  position: absolute;
  top: 22.8%;
  left: 6%;
  font-size: 8px;
  font-weight: bold;
`

const PlayTimeWeekDay = styled(PlayTimeBase)``

const PlayTimeWeekEnd = styled(PlayTimeBase)`
  left: 25%;
`

const VCOk = styled.div`
  position: absolute;
  top: 21.5%;
  left: 56%;
  border: solid 2px;
  border-radius: 50%;
  width: 18.5px;
  height: 18.5px;
`

const VCNg = styled.div`
  position: absolute;
  top: 21.5%;
  left: 80%;
  border: solid 2px;
  border-radius: 50%;
  width: 18.5px;
  height: 18.5px;
`

const VCText = styled.div`
  position: absolute;
  top: 18%;
  left: 65.5%;
  width: 10%;
  height: 12.5%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const KillerBase = styled.div<{ color: string }>`
  position: absolute;
  top: 30.5%;
  left: 10%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 1.5px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`
const Killer0 = styled(KillerBase)``
const Killer1 = styled(KillerBase)`
  left: 19%;
`
const Killer2 = styled(KillerBase)`
  left: 27.5%;
`
const Killer3 = styled(KillerBase)`
  left: 35%;
`
const Killer4 = styled(KillerBase)`
  left: 43%;
`
const Killer5 = styled(KillerBase)`
  left: 51%;
`
const Killer6 = styled(KillerBase)`
  left: 59%;
`
const Killer7 = styled(KillerBase)`
  left: 67.5%;
`
const Killer8 = styled(KillerBase)`
  left: 76%;
`
const Killer9 = styled(KillerBase)`
  left: 84.5%;
`
const Killer10 = styled(KillerBase)`
  //２列目
  top: 39.5%;
  left: 10%;
`
const Killer11 = styled(KillerBase)`
  top: 39.5%;
  left: 18%;
`
const Killer12 = styled(KillerBase)`
  top: 39.5%;
  left: 26.5%;
`
const Killer13 = styled(KillerBase)`
  top: 39.5%;
  left: 34.5%;
`

const Killer14 = styled(KillerBase)`
  top: 39.5%;
  left: 42.5%;
`
const Killer15 = styled(KillerBase)`
  top: 39.5%;
  left: 50%;
`
const Killer16 = styled(KillerBase)`
  top: 39.5%;
  left: 58%;
`
const Killer17 = styled(KillerBase)`
  top: 39.5%;
  left: 67.5%;
`
const Killer18 = styled(KillerBase)`
  top: 39.5%;
  left: 76%;
`
const Killer19 = styled(KillerBase)`
  top: 39.5%;
  left: 84.5%;
`
const Killer20 = styled(KillerBase)`
  //3列目
  top: 48%;
  left: 9.5%;
`
const Killer21 = styled(KillerBase)`
  top: 48%;
  left: 18%;
`
const Killer22 = styled(KillerBase)`
  top: 48%;
  left: 26%;
`

const Killer23 = styled(KillerBase)`
  top: 48%;
  left: 34.5%;
`

const Killer24 = styled(KillerBase)`
  top: 48%;
  left: 42.5%;
`

const Killer25 = styled(KillerBase)`
  top: 48%;
  left: 51.5%;
`

const Killer26 = styled(KillerBase)`
  top: 48%;
  left: 61.5%;
`

const Killer27 = styled(KillerBase)`
  top: 48%;
  left: 71.5%;
`

const Killer28 = styled(KillerBase)`
  top: 48%;
  left: 81.5%;
`

const SurvivorBase = styled.div<{ color: string }>`
  position: absolute;
  top: 63.5%;
  left: 6%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 1.5px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const Survivor0 = styled(SurvivorBase)``
const Survivor1 = styled(SurvivorBase)`
  left: 13.5%;
`
const Survivor2 = styled(SurvivorBase)`
  left: 21.5%;
`
const Survivor3 = styled(SurvivorBase)`
  left: 30%;
`
const Survivor4 = styled(SurvivorBase)`
  left: 37.5%;
`
const Survivor5 = styled(SurvivorBase)`
  left: 45.5%;
`

const Survivor6 = styled(SurvivorBase)`
  left: 53%;
`

const Survivor7 = styled(SurvivorBase)`
  left: 60.5%;
`

const Survivor8 = styled(SurvivorBase)`
  left: 68.5%;
`

const Survivor9 = styled(SurvivorBase)`
  left: 78%;
`

const Survivor10 = styled(SurvivorBase)`
  left: 86%;
`

const Survivor11 = styled(SurvivorBase)`
  //2列目
  top: 72.5%;
  left: 6%;
`

const Survivor12 = styled(SurvivorBase)`
  top: 72.5%;
  left: 14%;
`

const Survivor13 = styled(SurvivorBase)`
  top: 72.5%;
  left: 22%;
`
const Survivor14 = styled(SurvivorBase)`
  top: 72.5%;
  left: 30%;
`

const Survivor15 = styled(SurvivorBase)`
  top: 72.5%;
  left: 39%;
`

const Survivor16 = styled(SurvivorBase)`
  top: 72.5%;
  left: 47%;
`

const Survivor17 = styled(SurvivorBase)`
  top: 72.5%;
  left: 54.5%;
`

const Survivor18 = styled(SurvivorBase)`
  top: 72.5%;
  left: 61%;
`

const Survivor19 = styled(SurvivorBase)`
  top: 72.5%;
  left: 70%;
`

const Survivor20 = styled(SurvivorBase)`
  top: 72.5%;
  left: 78%;
`

const Survivor21 = styled(SurvivorBase)`
  top: 72.5%;
  left: 86%;
`

const Survivor22 = styled(SurvivorBase)`
  //3列目
  top: 83.5%;
  left: 6%;
`

const Survivor23 = styled(SurvivorBase)`
  top: 83.5%;
  left: 14%;
`

const Survivor24 = styled(SurvivorBase)`
  top: 83.5%;
  left: 21.5%;
`

const Survivor25 = styled(SurvivorBase)`
  top: 83.5%;
  left: 29.5%;
`

const Survivor26 = styled(SurvivorBase)`
  top: 83.5%;
  left: 36.5%;
`

const Survivor27 = styled(SurvivorBase)`
  top: 83.5%;
  left: 46%;
`

const Survivor28 = styled(SurvivorBase)`
  top: 83.5%;
  left: 54%;
`

const Survivor29 = styled(SurvivorBase)`
  top: 83.5%;
  left: 62.5%;
`

const Survivor30 = styled(SurvivorBase)`
  top: 83.5%;
  left: 70.5%;
`

const Survivor31 = styled(SurvivorBase)`
  top: 83.5%;
  left: 78.5%;
`

const Survivor32 = styled(SurvivorBase)`
  top: 83.5%;
  left: 86%;
`
